import { useLocale } from '@/hooks/useLocale';

interface LocalizedLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: React.ReactNode;
}

/** Anchor that preserves locale prefix for internal paths */
export const LocalizedLink = ({ href, children, ...props }: LocalizedLinkProps) => {
  const { toLocalizedPath } = useLocale();

  const isInternal = href.startsWith('/') && !href.startsWith('//');
  const isHashOnly = href.startsWith('/#') || href.startsWith('#');
  const resolvedHref = isInternal
    ? isHashOnly
      ? `${toLocalizedPath('/')}${href.replace(/^\/?/, '')}`
      : toLocalizedPath(href.split('#')[0]) + (href.includes('#') ? href.slice(href.indexOf('#')) : '')
    : href;

  return (
    <a href={resolvedHref} {...props}>
      {children}
    </a>
  );
};
